import { render, staticRenderFns } from "./CardItemLotesConfirmados.vue?vue&type=template&id=12486bd2&scoped=true&"
import script from "./CardItemLotesConfirmados.vue?vue&type=script&lang=js&"
export * from "./CardItemLotesConfirmados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12486bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
